export default __webpack_public_path__ + "static/media/events-lt.3354e75d.png";